import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { SpinService } from './spin.service';

@Component({
  selector: 'app-spin',
  templateUrl: 'spin.component.html',
  styleUrls: ['./spin.component.css'],
  standalone: true,
})
export class SpinComponent implements OnInit, OnDestroy {
  private readonly spinService = inject(SpinService);

  private spin$: Subscription = new Subscription();

  readonly show = signal(false);

  ngOnInit(): void {
    this.spin$ = this.spinService.getService().subscribe((isVisible: boolean) => {
      this.show.set(isVisible);
    });
  }

  ngOnDestroy(): void {
    this.spin$.unsubscribe();
  }
}
